import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { logger } from "@/lib/logger";

const container = document.getElementById("root")!;

createRoot(container, {
  onUncaughtError: (error, errorInfo) => {
    logger.error("Uncaught error", error, { componentStack: errorInfo.componentStack });
  },
  onCaughtError: (error, errorInfo) => {
    logger.error("Caught error", error, { componentStack: errorInfo.componentStack });
  },
}).render(<App />);
